import $, { css, get } from "jquery";
import 'select2';
export default function initializeCalculator() {
	const selectedProducts = [];
	let storageStep = 0;
	let selectedProductsTwo = [];
	let selectedProductsCustom = [];
	let custom_product = 0;
	if(localStorage.getItem('selectedProductsCustomCount')!=null){
		 selectedProductsCustom = JSON.parse(localStorage.getItem('selectedProductsCustomCount'));
		 custom_product = selectedProductsCustom[selectedProductsCustom.length-1];					
	}	
	$(".calculator .our-options__item .radio_p").each(function(){
		$(this).on('change', function () {		
  	      handleCheckboxChangeProd($(this));  	        	        	      
		});  	 
		const savedState = localStorage.getItem('productCalculator_' + $(this).val());
		 if (savedState === 'checked') { 
			 $(this).attr("checked","checked");
		 }
	});	
	
	$(".tabs").find('.tab').each(function(){		
		if($(this).hasClass("active")){			
			$('.'+$(this).attr("rel")).show();
		}
		$(this).on("click",function(){
			$(".simulator").hide();
			$('.'+$(this).attr("rel")).show();
		});
	});
		
	if(!localStorage.getItem('currentStepCalc'))localStorage.setItem('currentStepCalc',0);
	
	$(".our-options__item").each(function(){
		$(this).bind("click",function(){			
			$(this).find(".radio_p").trigger('change');
		});
	});
	$(".next-btn-option").on('click',function(){	
			showPreloader();
			//$(this).find('.radio_p')[0].click();		
			$('#dof-checkout__smartwizard').smartWizard('goToStep', 1);
			$("#calc-form .motion-simulators-menu").hide();
			if(storageStep==0)localStorage.setItem('currentStepCalc',1);						
			$("#step-1").hide();
			$("#step-2").show();			
			$.ajax({
		            type: 'POST',
		            url: wc_add_to_cart_params.ajax_url,
		            data: {
		                action: 'load_options'
		                /*productID: $(this).find('.radio_p').attr("value")*/
		            },
		            success: function (response) {
		            	hidePreloader();
		            	$("#step-2").html(response);
		            	 $('.addToCartCheckbox').on('change', function () {
		            	      handleCheckboxChangeCalc($(this));
		            	 });
		            	 $(".addToCartCheckbox").each(function(){
		            		 const savedStateOpt = localStorage.getItem('optionCalculator_' + $(this).attr("data-product-id"));
			        		 if (savedStateOpt === 'checked') { 
			        			 $(this).attr("checked","checked");
			        			 handleCheckboxChangeCalc($(this));
			        		 }			            		 
		            	  });
		            	  $(".prev-btn-calc").unbind("click").bind("click",function(){			            		 
		            		 $('#dof-checkout__smartwizard').smartWizard('goToStep', 0);
		            		 $("#step-1").show();
		            		 $("#step-2").hide();	
		            		 $("#step-2").html('<center><h1>Load options for simulator...</h1></center>');
		            		 localStorage.setItem('currentStepCalc',0);
		            		 $("#calc-form .motion-simulators-menu").show();		            		
		            	 });
		            	 $(".next-btn-calc").unbind("click").bind("click",function(){
		            		 showPreloader();
		            		 if(localStorage.getItem('currentStepCalc')==1)storageStep=0;
		            		 if(storageStep==0){		            			 
		            			 localStorage.setItem('currentStepCalc',2);		            			 
		            		 }		            		
		            		 $('#dof-checkout__smartwizard').smartWizard('goToStep', 2);
		            		 $("#step-2").hide();
		            		 $("#step-3").show();	
		            		 $(".step-3").show();
		            		 $("#calc-form").addClass("checkout-form");
		            		 $("#calc-form").addClass("checkout");
		            		 $("#calc-form").addClass("woocommerce-checkout");
		            		 $(".dof-checkout__content").removeClass("container");
		            		 let selectedProductsTwo=[];
		            		 $(".addToCartCheckbox").each(function(){		          
		            			 if($(this).is(':checked')){
		            				 selectedProductsTwo.push($(this).attr("data-product-id"));
		            			 }
		            		 });		            		
		            		 $(".radio_p").each(function(){		          
		            			 if($(this).is(':checked')){
		            				 selectedProductsTwo.push($(this).attr("data-product-id"));
		            			 }
		            		 });
		            		 if(localStorage.getItem("billing_first_name_calc")){
		            			$("#billing_first_name").attr('value',localStorage.getItem("billing_first_name_calc"));
		            		 }
		            		 if(localStorage.getItem("billing_last_name_calc")){
		            			$("#billing_last_name").attr('value',localStorage.getItem("billing_last_name_calc"));
		            		}
		            		if(localStorage.getItem("billing_email_calc")){
		            			$("#billing_email").attr('value',localStorage.getItem("billing_email_calc"));
		            		}
		            		$("#order_form_find").show();
		            		$("#order_form_find").find("#search-button-map").unbind("click").bind("click",function(){
		            			$.ajax({
		        		            type: 'POST',
		        		            url: wc_add_to_cart_params.ajax_url,
		        		            datatype: "json",
		        		            data: {
		        		                action: 'load_order',
		        		                orderID: $('#search-input-order-id').val()
		        		            },
		        		            success: function (response) {
		        		            	 var data = JSON.parse(response);
		        		            	 $("#billing_first_name").attr('value',data.name);
		     		            		 $("#billing_last_name").attr('value',data.fname);
		     		            		 $("#billing_email").attr('value',data.email);		     		            			
		     		            		 $(".next-btn-ship").trigger("click");
		     		            		 $('select#billing_country').val(data.addr_country);			
		     		           			 setTimeout(function(){
		     		           				$('select#billing_country').trigger("change");;
		     		           			 	$("#billing_address_1").attr('value',data.addr_street);
		     		           			 	$("#billing_address_2").attr('value',data.address);
		     		           			 	$("#billing_city").attr("value",data.addr_city);
		     		           			 	$("#billing_postcode").attr("value",data.addr_zip);
		     		           			 	$("#billing_company").attr("value",data.company_name);			     		           			 	
		     		           			setTimeout(function(){
		     		           			 	$("select#billing_state").val(data.addr_state);
		     		           			 	$("select#billing_state").trigger("change");		    
		     		           			 	$("#user_phone").attr("value",data.addr_phone);	
		     		           			 	$('#user_phone').mask("99999999999", { placeholder: data.addr_phone});
		     		           		},1000);
		     		           			},200)		     		           		 
		        		            }
		            			});
		            		});	
		            		 $.ajax({
		     		            type: 'POST',
		     		            url: wc_add_to_cart_params.ajax_url,
		     		            data: {
		     		                action: 'load_calc_cart',
		     		                selected_products: selectedProductsTwo,
		     		                email: $("#billing_email").val()
		     		            },
		     		            success: function (response) {
		     		            	$(".dof-checkout__cart").html(response);	
		     		            	
		     		            	$(".proceed-custom").bind("click",function(){
		     		            		 $.magnificPopup.open({
		     		        	        	items: {
		     		        	        		src: '#custom-popup', // Replace 'your-popup-id' with the ID of your popup content
		     		        	        		type: 'inline'
		     		        	        	},
		     		        	        	removalDelay: 500, // Delay removal by X to allow out-animation
		     		        	        	fixedContentPos: true,
		     		        	        	mainClass: 'add-product-popup__wrap',
		     		        	        	closeOnBgClick: false,
		     		        	        	midClick: true,
		     		        	        	callbacks: {
		     		        	        		beforeOpen: function () {
		     		        	        			this.st.mainClass = 'mfp-zoom-in add-product-popup__wrap'; // Add your desired animation class
		     		        	        		},
		     		        	        		beforeClose: function () {
		     		        	        			this.st.mainClass = 'mfp-zoom-out'; // Add your desired animation class
		     		        	        		}
		     		        	        	}
		     		        	        });
		     		            	});
		     		            	
		     		            	$(".proceed-custom-save").on('click',function(){
		     		            		showPreloader();
		     		            		custom_product= custom_product+1;
		     		            		var title = $("#custom-form-add").find("#custom-title").val();
		     		            		var price = $("#custom-form-add").find("#custom-price").val();
		     		            		var shipping = $("#custom-form-add").find("#custom-shipping").val();
		     		            		var qty = $("#custom-form-add").find("#custom-qty").val();
		     		            		var productData = {
				            	               name: title,
				            	               model: "custom",				            	                   
				            	               price: price,
				            	               shipping: shipping,
				            	               qty: qty
				            	        };		     	
		     		            		localStorage.setItem('selectedProductsCustom_'+custom_product,JSON.stringify(productData));		     		            		
		     		            		selectedProductsCustom.push(custom_product);
		     		            		localStorage.setItem('selectedProductsCustomCount',JSON.stringify(selectedProductsCustom));
		     		            		var html_prod = '<div class="dof-cart__product__inner product-item main-product custom_product" id="custom_product-'+custom_product+'" data-product-type="custom" shipping-attribute="OO" shipping-product-custom="'+shipping+'" data-product-id="74" data-enable-warranty-cart="" data-enable-warranty-percentage="" data-quantity="'+qty+'">';
		     		            		html_prod = html_prod+'<div class="dof-cart__product__image">';
		     		            		html_prod = html_prod+'<img width="150" height="150" src="/wp-content/themes/dofreality/images/no-photo-or-blank-image-icon-loading-images.jpg" class="attachment-thumbnail size-thumbnail has-transparency">';
		     		            		html_prod = html_prod+'</div><div class="dof-cart__product__info">';
		     		            		html_prod = html_prod+'<h6>'+title+'</h6></div>';		     		                                                    		     		                    
		     		            		html_prod = html_prod+'<div class="dof-cart__product__price">$'+price+'</div>';   
		     		            		html_prod = html_prod+'<div class="cart-product__quantity" style="margin-top:60px;" rel="'+price+'">';
		     		            		html_prod = html_prod+'<div class="cart-product__info-text"><div class="item-name-title quantity quantity-custom">';		     		                    		
		     		            		html_prod = html_prod+'<div class="quantity-nav"><div class="quantity-button quantity-down">-</div><input type="number" min="1" name="qty[]" step="1" id="qty" value="'+qty+'" class="qty_val"><div class="quantity-button quantity-up">+</div></div></div>';
		     		            		html_prod = html_prod+'</div><div class="cart-product__info-text"><div class="dof-cart__remove"><button class="cart-remove" data-cart-remove-product-id="'+custom_product+'">×</button></div></div></div></div></div>';
		     		            		$(html_prod).insertBefore(".proceed-custom");
		     		            		$.magnificPopup.close();
		     		            		addSpinner($("#custom_product-"+custom_product).find(".quantity-custom"));
		     		            		$("#custom_product-"+custom_product).find(".cart-remove").bind('click',function(){
		     		            			let product_id = $(this).attr("data-cart-remove-product-id"); 
		     		            			$("#custom_product-"+product_id).remove();
		     		            			localStorage.removeItem('selectedProductsCustom_'+product_id);		     		            			
		     		            		});
		     		            		hidePreloader();
		     		            		calculateTotalSubtotal()
		     		            		$('#calc-form #billing_country').trigger("change");
		     		            	});
		     		            	
		     		            	$('.dof-checkout__cart .quantity').each(function() {
		     		            		$('<div class="quantity-nav"><div class="quantity-button quantity-down">-</div><input type="number" min="1"  name="qty[]" step="1" id="qty" value="1" class="qty_val"><div class="quantity-button quantity-up">+</div></div>').appendTo($(this));
		     		            		addSpinner(this);
		     		               });
		     		            	 $("#apply_promo_button").on('click', function (event) {    	
		     		                    event.preventDefault();
		     		                    addDiscount(); 
		     		                });
		     		            	 		     		            	 
		     		            	hidePreloader();
		     		            	setTimeout(function(){
				            				if(localStorage.getItem('currentStepCalc')==3){
				            					$(".next-btn-ship").trigger("click");
				            				}		
				            				}
				            		 ,100);		     		             
		     		            	if(localStorage.getItem('selectedProductsCustomCount')){		     		            		
		     		            		for(var j=0;j<selectedProductsCustom .length;j++){
		     		            		if(localStorage.getItem('selectedProductsCustom_'+selectedProductsCustom[j])){
		     		            			var el = JSON.parse(localStorage.getItem('selectedProductsCustom_'+selectedProductsCustom [j]));		     		            			
		     		            			var html_prod = '<div class="dof-cart__product__inner product-item main-product custom_product" id="custom_product-'+selectedProductsCustom [j]+'" data-product-type="custom" shipping-attribute="OO" shipping-product-custom="'+el["shipping"]+'" data-product-id="74" data-enable-warranty-cart="" data-enable-warranty-percentage="" data-quantity="'+el["qty"]+'">';
		     		            				html_prod = html_prod+'<div class="dof-cart__product__image">';
		     		            				html_prod = html_prod+'<img width="150" height="150" src="/wp-content/themes/dofreality/images/no-photo-or-blank-image-icon-loading-images.jpg" class="attachment-thumbnail size-thumbnail has-transparency">';
		     		            				html_prod = html_prod+'</div><div class="dof-cart__product__info">';
		     		            				html_prod = html_prod+'<h6>'+el["name"]+'</h6></div>';		     		                                                    		     		                    
		     		            				html_prod = html_prod+'<div class="dof-cart__product__price">$'+el["price"]+'</div>';   
		     		            				html_prod = html_prod+'<div class="cart-product__quantity" style="margin-top:60px;" rel="'+el["price"]+'">';
		     		            				html_prod = html_prod+'<div class="cart-product__info-text"><div class="item-name-title quantity quantity-custom">';		     		                    		
		     		            				html_prod = html_prod+'<div class="quantity-nav"><div class="quantity-button quantity-down">-</div><input type="number" min="1" name="qty[]" step="1" id="qty" value="'+el["qty"]+'" class="qty_val"><div class="quantity-button quantity-up">+</div></div></div>';
		     		            				html_prod = html_prod+'</div><div class="cart-product__info-text"><div class="dof-cart__remove"><button class="cart-remove" data-cart-remove-product-id="'+selectedProductsCustom[j]+'">×</button></div></div></div></div></div>';		     		            		
		     		            				$(html_prod).insertBefore(".proceed-custom");
		     		            				addSpinner($("#custom_product-"+selectedProductsCustom[j]).find(".quantity-custom"));
		     		            				$("#custom_product-"+selectedProductsCustom[j]).find(".cart-remove").bind('click',function(){
		     		            					let product_id = $(this).attr("data-cart-remove-product-id"); 
		     		            					$("#custom_product-"+product_id).remove();
		     		            					localStorage.removeItem('selectedProductsCustom_'+product_id);		     		            			
		     		            				});
		     		            			}
		     		            		}
		     		            		calculateTotalSubtotal();
		     		            	}
		     		            }});
		            		 $(".prev-btn-info").unbind("click").bind("click",function(){
		            			 $('#dof-checkout__smartwizard').smartWizard('goToStep', 1);
		            			 localStorage.setItem('currentStepCalc',1);
			            		 $("#step-2").show();
			            		 $("#step-3").hide();	
			            		 $(".step-3").hide();
			            		 $("#calc-form").removeClass("checkout-form");
			            		 $("#calc-form").removeClass("checkout");
			            		 $("#calc-form").removeClass("woocommerce-checkout");
			            		 
			            		 $(".dof-checkout__content").addClass("container");		
			            		 $(".dof-checkout__cart").html('<center><h1>Load cart...</h1></center>');
			            		 $("#order_form_find").hide();
		            		 });		            		 
		            		 $(".next-btn-ship").unbind("click").bind("click",function(){
		            			 
		            			 var fname = $('#billing_first_name').val();
	            	             var lname = $('#billing_last_name').val();
	            	             var email = $('#billing_email').val();
	            	             
		            			 localStorage.setItem("billing_first_name_calc",fname);
		                         localStorage.setItem("billing_last_name_calc",lname);
		                         localStorage.setItem("billing_email_calc",email);
		                         
		            			 $('#dof-checkout__smartwizard').smartWizard('goToStep', 3);
		            			 if(localStorage.getItem('currentStepCalc')==2)storageStep=0;
		            			 if(storageStep==0)localStorage.setItem('currentStepCalc',3);		            			
		            			 $("#step-3").hide();
		            			 $("#step-4").show();		            			 
		            			 $(".checkout-promo").show();
		            			 $('#calc-form #billing_country').trigger("change");		            			
		            		 });
		            		 $(".prev-btn-ship").unbind("click").bind("click",function(){
		            			 $('#dof-checkout__smartwizard').smartWizard('goToStep', 2);
		            			 localStorage.setItem('currentStepCalc',2);
		            			 $("#step-3").show();
		            			 $("#step-4").hide();
		            			 $(".delivery-price").html('Calculated at next step');
		            			 $(".dof-tax").html('Calculated at next step');
		            			 $(".total").html('');
		            			 $(".checkout-promo").hide();
		            		 });		            		
		            		 
		            		 $(".proceed-invoice").each(function(){
		            			 
		            			 $(this).unbind("click").bind("click",function(){
		            			  // Create the checkout data object
		            			 	var billingCountryField = $('#billing_country');
		            	            var selectedCountryOption = billingCountryField.find('option:selected');
		            	            var billingStateField = $('#billing_state');
		            	            var selectedStateOption = billingStateField.find('option:selected');
		            	            var billingStateInput = $('#hidden_billing_state').val();
		            	            var dofAccountPayment = $('#step-2').attr('dof-payment-choose');
		            	            var currency="$";	
		            	            var products = [];
		            	            var type_calc=$(this).attr("rel");
		            	            $('.dof-cart__product__inner').each(function () {
		            	                var productInfo = $(this).find('.dof-cart__product__info');
		            	                var hasOurOption = $(this).hasClass('our-option'); // Check if it has our-option class
		            	                var isMainProduct = $(this).hasClass('main-product'); // Check if it's a main-product
		            	                var shippingAttribute = $(this).attr('shipping-attribute');
		            	                var dataProductType = $(this).attr('data-product-type');
		            	                var shippingProduct = $(this).attr('shipping-product');
		            	                var shippingProductCustom = $(this).attr('shipping-product-custom');
		            	                var usage = $(this).attr('data-usage');
		            	                var productName = productInfo.find('h6').text();
		            	                var productPrice = $(this).find('.dof-cart__product__price').text().trim();
		            	                var href=$(this).find('a').attr("href");
		            	                // Remove dollar sign and spaces from the price
		            	                productPrice = productPrice.replace(currency, '').replace(/\s/g, '');
		            	                var qty = $(this).find('.qty_val').val();
		            	                // Determine the option based on the presence of .our-option, excluding main-product
		            	                var optionText = hasOurOption ? 'Our Option' : 'Partner Option';
		            	                // Add product data to the array, excluding option if it's a main-product
		            	                var productData = {
		            	                    name: productName,
		            	                    model: shippingAttribute,
		            	                    product_type: dataProductType,
		            	                    price: productPrice,
		            	                    shipping: shippingProduct,
		            	                    shippingCustom: shippingProductCustom,
		            	                    qty: qty		            	                    
		            	                };
		            	                
		            	                productData.option = optionText;
		            	                
		            	                products.push(productData);
		            	            });
		            	            
		            	            var discountCode = $('#promo_code').val().trim(); // Get entered discount code
		            	            var discountCodeSum = $('.discount-code-sum').text();
		            	            var discountPercent = $('.discount-code-sum').attr("percent");
		            	            var subtotal = $('.subtotal .woocommerce-Price-amount').text().trim();
		            	            var deliveryPrice = $('.delivery-price').text().trim();
		            	            var dofTax = $('.dof-tax').text().trim();		            	            
		            	            if (discountCode || discountCode=='') {
		            	                var total = $('.total .woocommerce-Price-amount').text().trim();			            	                
		            	            } else {
		            	                var total = $('.total .woocommerce-Price-amount .amount').text().trim();		            	                
		            	            }
		            	            		            	            
		            	            // Remove dollar signs from various price-related fields
		            	            discountCodeSum = discountCodeSum.replace(currency, '').replace(/\s/g, '');
		            	            subtotal = subtotal.replace(currency, '').replace(/\s/g, '');
		            	            deliveryPrice = deliveryPrice.replace(currency, '').replace(/\s/g, '');
		            	            dofTax = dofTax.replace(currency, '').replace(/\s/g, '');
		            	            total = total.replace(currency, '').replace(/\s/g, '');

		            	            var checkoutData = {
		            	            	discount_code_percent: discountPercent,
		            	                billing_first_name: $('#billing_first_name').val(),
		            	                billing_last_name: $('#billing_last_name').val(),
		            	                billing_country_name: selectedCountryOption.text(),
		            	                billing_country_code: selectedCountryOption.val(),
		            	                billing_address_1: $('#billing_address_1').val(),
		            	                billing_address_2: $('#billing_address_2').val(),
		            	                billing_city: $('#billing_city').val(),
		            	                billing_state_name: billingStateInput ? billingStateInput : selectedStateOption.text(),
		            	                billing_state_code: selectedStateOption.val(),
		            	                billing_postcode: $('#billing_postcode').val(),
		            	                billing_phone: $('#user_phone').val(),
		            	                billing_email: $('#billing_email').val(),
		            	                company: $('#billing_company').val(),		            	                
		            	                products: products,
		            	                discount_code: discountCode,
		            	                discount_code_sum: discountCodeSum,		            	                
		            	                subtotal: subtotal,
		            	                delivery_price: deliveryPrice,
		            	                dof_tax: dofTax,
		            	                total: total,
		            	                account_code: dofAccountPayment,
		            	                invoice_header:$("#invoice_header").val(),
		            	                invoice_comment:$("#invoice_comment").val(),
		            	                invoice_note:$("#invoice_note").val()
		            	            };			            	            
		            			 $.ajax({
				     		            type: 'POST',
				     		            url: wc_add_to_cart_params.ajax_url,
				     		            datatype: "json",
				     		            data: {
				     		                action: 'load_invoice',		
				     		                type_calc: type_calc,
				     		                checkout_data: checkoutData 
				     		            },  success: function (response) {				   				     		            	
				     		            	location.href="/calculator/?orderID="+response;				     		            	
				     		            }
		            			 });
		            		 });
		            		});
		            	 });
		            	 setTimeout(function(){
	            				if(localStorage.getItem('currentStepCalc')>1){
	            					$(".next-btn-calc").trigger("click");
	            				}		
	            				}
	            		 ,100);
		            }
			  });
		//});	
	});
	
	setTimeout(function(){
		if(localStorage.getItem('currentStepCalc')>0){
			storageStep=1;
			$(".next-btn-option").trigger("click");
		}		
		}
	,100);
	
	function calculateTotalSubtotal(qty) {
		let subtotal = 0;
		$('.dof-cart__product__inner').each(function () {
			let qty = $(this).find(".qty_val").val();	
			subtotal = subtotal+parseFloat($(this).find(".cart-product__quantity").attr("rel"))*qty;
		});
		 $(".dof-checkout__cart .subtotal .amount").html('<bdi><span class="woocommerce-Price-currencySymbol">$</span>'+subtotal);
		 $(".dof-checkout__cart .subtotal").attr('rel',subtotal);
    	 if($(".delivery-price .woocommerce-Price-currencySymbol").height()>0){
    		 $('#calc-form #billing_country').trigger("change");
    	  }		 
	}
	function calculateAmountToDeduct() {
        let totalDeductAmount = 0;
        const currency="$";
        $('.dof-cart__product__inner').each(function () {
            var $productItem = $(this).closest('.dof-cart__product__inner');
            if (!$productItem.hasClass('cart-enable_warranty')) {
                // Check if the product has the class cart-enable_warranty
                if ($(this).hasClass('main-product') || $(this).hasClass('our-option')) {
                    // const priceElement = $(this).find('.dof-cart__product__price .woocommerce-Price-amount');
                    const priceElement = $(this).find('.dof-cart__product__price');
                    const shipping = $(this).attr("shipping-product-crm");                    
                    if (priceElement.length) {
                        // const priceText = priceElement.text();
                        // const price = parseFloat(priceText.replace('$', '').trim());
                        const priceText = priceElement.text().trim().replace(/\s/g, '');
                        const price = parseFloat(priceText.replace(currency, '').replace(' ', ''));
                        let qty =$productItem.find(".qty_val").val();	
                        totalDeductAmount += (price - shipping)*qty;
                    }
                }
            }
        });

        return totalDeductAmount;
    }

	
	function addDiscount(){
	const currency="$";
   	 const dofCountry = $('.tab-pane').find('select#billing_country').val();
        if (dofCountry == '') {
            $("#promo_error").css("color", "red").text("To apply the promo code, you need to select a country");
        } else {
            const code = $("#promo_code").val().toLowerCase();
            // const amountToDeductPartner = calculateAmountToDeductPartner();
            const amountToDeduct = calculateAmountToDeduct();
            // const promoCode = $('.total .woocommerce-Price-amount span').data("promo-code");
            // const discountPercentage = $('.total .woocommerce-Price-amount span').data("discounte");
            // console.log('====================================');
            // console.log(amountToDeduct);
            // console.log('====================================');            
            var model=$("div[data-product-type='simulator']").attr('shipping-attribute');
            var sale_price = $("div[data-product-type='simulator']").attr('sale_price');
            var rate = $("#promo_code").attr('rate');
            $.ajax({
                url: '../proxy.php',
                type: 'GET',
                data: {
                    code: code,
                    amount: amountToDeduct,
                    model: model,
                    sale_price: sale_price*$("#qty").val(),
                    rate: rate,
                    email : localStorage.getItem("billing_email")
                },
                success: function (data) {                       	                	
                    let percentageDiscount = 0;
                    let discountSumResult = 0;
                	if(data['percent']){
                		percentageDiscount=data['percent'];                		
                		data = data['amount'];
                	}else{
                		percentageDiscount = ((amountToDeduct - data) / amountToDeduct) * 100;
                	}
                	
                	discountSumResult = amountToDeduct - data;
                	
                    let roundedPercentageDiscount = Math.round(percentageDiscount);
                    let dofCheckoutCart = $('.dof-checkout__cart');
                    let cartProductInfo = $('.cart-product__info');

                    const codeAttr = data != amountToDeduct ? code : '';
                    let shippingAmountText = dofCheckoutCart.find('.delivery-price .woocommerce-Price-amount').text();
                    let shippingAmount = Math.round(parseFloat(shippingAmountText.replace(currency, '').trim()));

                    let subTotalPrice = 0;
                    let subTotalWarrantyPrice = 0;

                    $('.product-item').each(function () {

                        var $productItem = $(this).closest('.product-item');
                        const productID = $(this).data('product-id');
                        const quantity = $("#qty").val()

                        const hasOurOption = $(this).hasClass('our-option');
                        const mainProduct = $(this).hasClass('main-product');
                        if (!$productItem.hasClass('cart-enable_warranty') && !$productItem.hasClass('no-discount')) {
                            if (mainProduct || hasOurOption) {
                                selectedProducts[productID] = quantity;
                                selectedProductIDs.push(productID);
                            }
                        }
                    });
                    if (data < amountToDeduct) {
                        let discountedAmount = Math.round(parseFloat(data.toFixed(2)));
                        // Convert to a number                            
                        let taxText = dofCheckoutCart.find('.dof-tax .woocommerce-Price-amount').text();
                        let taxAmount = Math.round(parseFloat(taxText.replace(currency, '').trim())); // Convert to a number
                        let subTotal = dofCheckoutCart.find('.total .woocommerce-Price-amount').text();                                                
                        subTotal = parseFloat(subTotal.replace(currency, '').trim().replace(',', ''));
                                                
                        subTotal = subTotal-discountSumResult-taxAmount-shippingAmount;
                        
                        

                        // Check if both discountedAmount and shippingAmount are valid numbers
                        if (!isNaN(discountedAmount)) {
                        	
                            var subTotalPriceElement = dofCheckoutCart.find('.subtotal .woocommerce-Price-amount');
                            if (subTotalPriceElement.length > 0) {
                                subTotalPriceElement.html('<bdi><span class="woocommerce-Price-currencySymbol">'+currency+'</span>' + subTotal + '</bdi>');
                            }
                            if(isNaN(shippingAmount)){
                            	shippingAmount=0;                            	
                            }
                            if(isNaN(taxAmount)){
                            	taxAmount=0;                            	
                            }
                            // Update the total amount with the formatted result                            
                            let totalAmount = subTotal + parseFloat(shippingAmount) + parseFloat(taxAmount); // Add them together
                            let totalPriceElement = dofCheckoutCart.find('.total .woocommerce-Price-amount');
                            if (totalPriceElement.length > 0) {
                                totalPriceElement.html('<bdi><span class="woocommerce-Price-currencySymbol" data-promo-code="' + codeAttr + '" data-discounte="' + roundedPercentageDiscount + '">'+currency+'</span>' + totalAmount + '</bdi>');
                            }


                            $("#promo_error").css("color", "green").text("Code Applied");

                            $('.cart-product__info .discount-code').css('display', 'flex');;
                            cartProductInfo.find('.discount-code .discount-code-sum').html('-'+ currency + parseFloat(discountSumResult.toFixed(1)));
                            cartProductInfo.find('.discount-code .discount-code-sum').attr("percent",roundedPercentageDiscount);
                            $("#apply_promo_button").hide();
                        } else {
                            // Handle cases where one or both values are not valid numbers
                            console.log('Invalid numbers: discountedAmount =' + discountedAmount + 'shippingAmount =' + shippingAmount);
                            // Display an error message or take appropriate action
                        }

                    } else {
                        $("#promo_error").css("color", "red").text("Sorry, the promo code is not valid");
                        $("#promo_code").val("");
                        localStorage.removeItem('promo_code');
                    }
                },
                error: function () {
                    $("#promo_error").css("color", "red").text("An error occurred while checking the promo code.");
                }
            });
        }      
   }
  function addSpinner(el) {	
	var spinner = $(el),
     input = spinner.find('input[type="number"]'),
     btnUp = spinner.find('.quantity-up'),
     btnDown = spinner.find('.quantity-down'),
     min = input.attr('min'),
     max = input.attr('max');

 	btnUp.click(function() {
 		var oldValue = parseFloat(input.val());
 		if (oldValue >= max) {
 			var newVal = oldValue;
 		} else {
 			var newVal = oldValue + 1;
 		}
 		spinner.find("input").val(newVal);
 		spinner.find("input").trigger("change");
 	});

 	btnDown.click(function() {
 		var oldValue = parseFloat(input.val());
 		if (oldValue <= min) {
 			var newVal = oldValue;
 		} else {
 			var newVal = oldValue - 1;
 		}
 		spinner.find("input").val(newVal);
 		spinner.find("input").trigger("change");
 	});
 	spinner.change(function(){		     		            	  	     		            	  
	  calculateTotalSubtotal();		     		            	 
 	});
   }
 
	//Function to show the preloader
	  function showPreloader() {
	      // Display your preloader element here
	      // For example:
	  	jQuery.blockUI({overlayCSS: {backgroundColor: '#fff',opacity:0.4},message:'' });
	  }

	  // Function to hide the preloader
	  function hidePreloader() {
	      // Hide your preloader element here
	      // For example:
	  	jQuery.unblockUI();
	  }
	  
    function handleCheckboxChangeCalc($checkbox) {
        const productId = $checkbox.data('product-id');
        const productType = $checkbox.data('product-type');
        const enableWarranty = $checkbox.data('enable-warranty');

        const isChecked = $checkbox.prop('checked');        

        if (isChecked && !enableWarranty) {
        	updateCheckboxStateCalc(productId, isChecked);
        } else if (isChecked && enableWarranty) {
            $('.option-list__row .option-list__col input[type="checkbox"][data-enable-warranty="enable-warranty"]').not($checkbox).prop('checked', false).parent().removeClass('checked');
            updateCheckboxStateCalc(productId, isChecked);
        } else {
        	updateCheckboxStateCalc(productId, isChecked);
        }
    }
        
    function updateCheckboxStateCalc(productId, isChecked) {
        const $checkboxes = $(".option-list").find(`.addToCartCheckbox[data-product-id="${productId}"]`);        	
        $checkboxes.each(function () {
            const $checkbox = $(this);
            $checkbox.prop('checked', isChecked);

            const $optionListInner = $checkbox.closest('.option-list__inner');
            if (isChecked) {
                $optionListInner.addClass('checked');
                localStorage.setItem('optionCalculator_' + productId, 'checked');
            } else {
                $optionListInner.removeClass('checked');
                selectedProducts.push($(this).attr("data-product-id"));
                localStorage.setItem('optionCalculator_' + productId, 'unchecked');
            }

            const newState = isChecked ? 'checked' : 'unchecked';            
        });
    }       
    
    function handleCheckboxChangeProd($checkbox) {
        const isChecked = $checkbox.prop('checked');        
        const productId = $checkbox.data('product-id');
        if (isChecked) {
        	const isChecked = $checkbox.removeAttr( "checked");
        	localStorage.setItem('productCalculator_' + $checkbox.val(), 'unchecked');
        } else {
        	const isChecked = $checkbox.attr('checked','checked');
        	localStorage.setItem('productCalculator_' + $checkbox.val(), 'checked');
        }
    }         
}